export const HOSPITAL_FOOTER_TYPE = "hospital_footer_type";
export const HOSPITAL_DETAIL_FOOTER_TYPE = "hospital_detail_footer_type";
export const DEFAULT_FOOTER_TYPE = "default_footer_type";
export const USER_FOOTER_TYPE = "user_footer_type";
export const DEFAULT_MAP_FOOTER_TYPE = "map_footer_type";
export const ADMIN_FOOTER_TYPE = "admin_footer_type";
